import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ITrainingType} from "../../../message-models/training-record-type.interface";
import {TrainingType} from "../../../message-models/training-record-type.class";
import { ListDataService } from '../../../services/list-data.service';
import { ITrainingTypeCategoryInfo } from '../../../message-models/trainning-record-category.interface';

@Component({
  selector: 'app-training-type-editor',
  templateUrl: './training-type-editor.component.html',
  styleUrls: ['./training-type-editor.component.scss']
})
export class TrainingTypeEditorComponent implements OnInit {
  @Input() trainingType: ITrainingType = new TrainingType();
  @Input() editingType: boolean = false;
  @Input() saveAttempted: boolean = false;
  allTrainingTypeCategory: ITrainingTypeCategoryInfo[] = [];
  constructor(private listDataService: ListDataService) { }

  ngOnInit(): void {
    this.listDataService.getAllTrainTypeCategory().subscribe({
      next: response => {
        this.allTrainingTypeCategory = response;
      }
    });
  }

}
